"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGPreviewPassword = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../..");

require("@fortawesome/fontawesome-pro/css/all.css");

require("./PreviewPassword.scss");

var BHGPreviewPassword = function BHGPreviewPassword(props) {
  var value = props.value,
      className = props.className,
      error = props.error,
      placeholder = props.placeholder,
      onChange = props.onChange,
      disabled = props.disabled,
      defaultState = props.defaultState;

  var _useState = (0, _react.useState)(defaultState),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPassword = _useState2[0],
      setShow = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bhg-preview-password"
  }, /*#__PURE__*/_react.default.createElement(_.BHGInput, {
    type: showPassword ? 'text' : 'password',
    value: value,
    error: error,
    placeholder: placeholder,
    onChange: onChange,
    disabled: disabled,
    className: className
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "preview-toggle",
    onClick: function onClick() {
      return setShow(!showPassword);
    }
  }, showPassword ? /*#__PURE__*/_react.default.createElement("i", {
    className: "fal fa-eye-slash"
  }) : /*#__PURE__*/_react.default.createElement("i", {
    className: "fal fa-eye"
  })));
};

exports.BHGPreviewPassword = BHGPreviewPassword;
BHGPreviewPassword.defaultProps = {
  disabled: false,
  value: '',
  error: false,
  placeholder: '',
  onChange: function onChange(e) {
    return console.log(e);
  },
  defaultState: false
};